import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { RegistrationContext } from '../../context/registration';
import { useToasts } from 'react-toast-notifications';

import { campaignWho } from '~/services/registration';

import { ProgressBar } from './ProgressBar';
import { otherTypeCodes } from '~/shared/config';
import {
  Container,
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Form,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

import { SelectOption } from '~/types/globals';
import { fetchCampaignIsForOptions } from '~/services/options';
import { Loading } from '../../shared/components/Loading';

const initialOptions = [
  {
    label: 'Myself',
    value: 'myself',
  },
  {
    label: 'Someone else',
    value: 'someone-else',
    footer:
      "We'll invite this person to accept the campaign that's being established in their honor.",
  },
];

export const Who = ({}: any) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [{ campaignRequest }, registrationDispatch] =
    useContext(RegistrationContext);
  const [campaign_is_forOptions, setCampaignIsForOptions] = useState<
    SelectOption[]
  >([]);

  console.log();
  const [initialOption, setInitialOption] = useState();
  const {
    register,
    handleSubmit,
    watch,
    errors,
    control,
    reset,
    setValue,
    getValues,
    formState: { isSubmitting },
  } = useForm({
    campaign_is_for: '',
  });
  if (errors) {
    console.log('errors: ', errors);
  }
  const { addToast } = useToasts();
  const history = useHistory();

  const getCampaignIsForOptions = async () => {
    try {
      const resp = await fetchCampaignIsForOptions();
      console.log('resp: ', resp);
      
      // Check if resp is an array
      if (Array.isArray(resp)) {
        const opts = resp
          .map((opt, i) => {
            return {
              label: opt.name,
              value: opt.code,
            };
          })
          .filter((x) => x.value !== 'self');
        setCampaignIsForOptions(opts);
      } else {
        console.error('Campaign options response is not an array:', resp);
        // Set default options if API fails
        setCampaignIsForOptions(initialOptions);
      }
    } catch (error) {
      console.error('Failed to fetch campaign options:', error);
      // Use default options as fallback
      setCampaignIsForOptions(initialOptions);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCampaignIsForOptions();
  }, []);

  const onSubmit = async (data) => {
    console.log('data: ', data);
    try {
      const resp = await campaignWho(data);
      console.log('resp: ', resp);

      registrationDispatch({
        type: 'set_campaign_request',
        campaignRequest: resp,
      });

      // Check campaign_is_for_id
      if (resp.campaign_is_for?.id == 1) {
        history.push('/get-started/condition/type');
      } else if (otherTypeCodes.includes(resp.campaign_is_for?.code)) {
        history.push('/get-started/other/terms');
      } else {
        history.push('/get-started/patient/who');
      }
    } catch (e) {
      console.log('e: ', e);
    }
  };

  useEffect(() => {
    if (initialOption === 'myself') {
      setValue('campaign_is_for', 'self');
    }
  }, [initialOption]);

  if (loading) {
    return <Loading />;
  }

  const isValid = watch('campaign_is_for');

  const header =
    initialOption && initialOption !== 'myself'
      ? `What's your relation to this person?`
      : `Who is in need of fundraising assistance?`;

  const InitialStep = () => {
    return (
      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormGroup check className='mb-3'>
          {initialOptions.map((opt, i) => {
            return (
              <div key={i}>
                <Label check>
                  <Input
                    type='radio'
                    value={opt.value}
                    onChange={() => setInitialOption(opt.value)}
                    name='initial_option'
                    checked={initialOption === opt.value}
                  />
                  {opt.label}
                </Label>
                <p className='mt-1'>
                  <em>{opt.footer}</em>
                </p>
              </div>
            );
          })}
        </FormGroup>
        <div className='text-center'>
          {initialOption && initialOption === 'myself' && (
            <Button
              color='primary'
              type='submit'
              disabled={!isValid || isSubmitting}
            >
              {isSubmitting ? `Saving...` : `Next`}
            </Button>
          )}
        </div>
      </Form>
    );
  };

  console.log(getValues('campaign_is_for'));
  let disclaimer = '';
  if (
    getValues('campaign_is_for') == 'guardian' ||
    getValues('campaign_is_for') == 'poa'
  ) {
    disclaimer =
      'You will be asked to submit supporting documentation. Please add that note under the words if selected.';
  }

  const NonSelfStep = () => {
    return (
      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormGroup check className='mb-3'>
          {/* <FormText>
            We'll invite this person to accept the campaign that's being
            established in their honor.
          </FormText> */}
          {campaign_is_forOptions.map((opt, i) => {
            return (
              <div key={i}>
                <Label check>
                  <Input
                    type='radio'
                    value={opt.value}
                    onChange={() => setValue('campaign_is_for', opt.value)}
                    name='campaign_is_for'
                    checked={getValues('campaign_is_for') === opt.value}
                  />
                  {opt.label}
                </Label>
              </div>
            );
          })}
        </FormGroup>
        <p>{disclaimer}</p>
        <div className='text-center'>
          <Button
            color='outline'
            disabled={isSubmitting}
            onClick={() => setInitialOption(null)}
          >
            Back
          </Button>
          <Button
            color='primary'
            type='submit'
            disabled={!isValid || isSubmitting}
          >
            {isSubmitting ? `Saving...` : `Next`}
          </Button>
        </div>
      </Form>
    );
  };

  return (
    <Container>
      <ProgressBar selectedStep='patient' />

      <Row className='justify-content-center py-5'>
        <Col md='6'>
          <div className='text-center'>
            <h3>{header}</h3>
          </div>

          <Card
            className='box-shadow my-5'
            style={{
              maxWidth: '400px',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <CardBody>
              {initialOption && initialOption !== 'myself' ? (
                <NonSelfStep />
              ) : (
                <InitialStep />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
